// Loading placeholders for the statistics page. Presentational only —
// a pulsing grey stand-in so each chart/card resolves independently
// without the whole page blocking on the slowest fetch.

interface ChartSkeletonProps {
  /** px height — defaults to StatsChart's own default so swapping in the
   * real chart causes no layout shift. */
  height?: number
}

/** Chart-shaped pulse placeholder: a row of bottom-aligned bars. */
export function ChartSkeleton({ height = 280 }: ChartSkeletonProps) {
  // Varied heights so it reads as "a chart", not a solid block.
  const bars = [55, 80, 40, 95, 65, 75, 50, 88, 60, 70]
  return (
    <div
      className="flex items-end gap-2 animate-pulse"
      style={{ height }}
      aria-hidden="true"
      data-testid="chart-skeleton"
    >
      {bars.map((h, i) => (
        <div
          key={i}
          className="flex-1 rounded bg-gray-200 dark:bg-gray-700"
          style={{ height: `${h}%` }}
        />
      ))}
    </div>
  )
}

/** Short pulse bar standing in for a KPI value — `h-7` ≈ the `text-2xl`
 * line height so the card keeps its size. */
export function CardSkeleton() {
  return (
    <div
      className="mt-1 h-7 w-20 rounded bg-gray-200 dark:bg-gray-700 animate-pulse"
      aria-hidden="true"
    />
  )
}
